module.exports = __webpack_public_path__ + "static/img/about15.b5e8549.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about15.png
// module id = WErq
// module chunks = 1